import { render, staticRenderFns } from "./InsuranceCustomers.vue?vue&type=template&id=19d83242&scoped=true"
import script from "./InsuranceCustomers.vue?vue&type=script&lang=js"
export * from "./InsuranceCustomers.vue?vue&type=script&lang=js"
import style0 from "./InsuranceCustomers.vue?vue&type=style&index=0&id=19d83242&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d83242",
  null
  
)

export default component.exports